import React, { useState, useEffect, useContext } from 'react';
import { Tree, Select, Row, Col, Checkbox, Space, Button, Typography, List } from 'antd';
import { MasterContext } from '../../App';
import './style';
import { CheckOutlined, CloseOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';

export default React.forwardRef((props, ref) => {
  const { onOk, filteredUsers, onCloseCallback } = props;
  const { user_category, user } = useContext(MasterContext);
  const [selectedCategoryId, setSelectedCategoryId] = useState(undefined);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUsersChecked, setSelectedUsersChecked] = useState([]);

  const [expandedKeys, setExpandedKeys] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);

  const onExpand = (expandedKeys) => {
    console.log('onExpand', expandedKeys);
    setExpandedKeys(expandedKeys);
    setAutoExpandParent(false);
  };

  const onAdd = () => {
    let temp = [].concat(selectedUsers);
    checkedKeys.map(item => (temp.push(
      {
        id: item,
        name: user.find(x => x.id === item).name,
      }
    )));
    setSelectedUsers(temp);
    setCheckedKeys([]);
  }

  const onDelete = () => {
    const temp = selectedUsers.filter(x => selectedUsersChecked.indexOf(x.id) < 0);
    setSelectedUsers(temp);
    setSelectedUsersChecked([]);
  }

  const onCheck = (checkedKeys) => {
    console.log('onCheck', checkedKeys);
    setCheckedKeys(checkedKeys);
  };

  const onSelect = (selectedKeys, info) => {
    console.log('onSelect', info);
    setSelectedKeys(selectedKeys);
  };


  const onButtonOk = () => {
    if (onOk) {
      onOk(selectedUsers);
    }
  }

  const onChangeCheck = (e, value) => {
    const temp = [].concat(selectedUsersChecked);
    const idx = temp.indexOf(value);
    if (e.target.checked) {
      if (idx < 0) {
        temp.push(value)
      }
    } else {
      if (idx >= 0) {
        temp.splice(idx, 1);
      }
    }
    setSelectedUsersChecked(temp);
  }

  return (
    <div style={{ padding: '1rem 0' }} >
      <Row gutter={[24, 24]}>
        <Col span={11}>
          <Row>
            <Select
              showSearch="true"
              placeholder="请选择用户分类"
              onChange={setSelectedCategoryId}
              style={{ width: '100%' }}
            >
              {user_category.map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Row>
          <Tree
            style={{ margin: '1rem 0', padding: '1rem', border: '1px solid #f0f0f0' }}
            checkable
            onExpand={onExpand}
            expandedKeys={expandedKeys}
            autoExpandParent={autoExpandParent}
            onCheck={onCheck}
            checkedKeys={checkedKeys}
            onSelect={onSelect}
            selectedKeys={selectedKeys}
            treeData={
              user.filter(x => x.category_id === selectedCategoryId && !selectedUsers.find(s=>s.id===x.id))
                .map(item => ({
                  title: item.name,
                  disableCheckbox: (filteredUsers || []).find(z => z.id === item.id),
                  key: item.id
                }))}
          />
        </Col>
        <Col span={2}>
          <div style={{ margin: '0 1.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <div>
              <div><Button disabled={checkedKeys.length === 0} onClick={onAdd} type="primary" icon={<RightOutlined />}>添加</Button></div>
              <br />
              <div><Button disabled={selectedUsersChecked.length === 0} onClick={onDelete} type="primary" icon={<LeftOutlined />}>删除</Button></div>
            </div>
          </div>
        </Col>
        <Col span={11}>
          <div>
            <List style={{ width: '100%' }}
              header={<div>已选择的用户</div>}
              footer={<div>Footer</div>}
              bordered
              dataSource={selectedUsers}
              renderItem={item => (
                <List.Item>
                  <Checkbox
                    checked={selectedUsersChecked.indexOf(item.id) >= 0}
                    onChange={(e) => onChangeCheck(e, item.id)}
                    style={{ paddingRight: '1rem' }}
                  />
                  <Typography.Text mark>[{item.id}]</Typography.Text> {item.name}
                </List.Item>
              )} />
          </div>

        </Col>

      </Row>
      <Row justify="end">
        <Space size="large">
          <div style={{ marginLeft: 'auto' }}></div>
          <Button onClick={onCloseCallback} icon={<CloseOutlined />}>关 闭</Button>
          <Button disabled={selectedUsers.length === 0} onClick={onButtonOk} type="primary" icon={<CheckOutlined />}>确 定</Button>
        </Space>
      </Row>
    </div>
  );
});
